// project imports
import { APP_PROVIDER_NAME } from 'config';

// assets
import Logo from 'assets/images/provider-logo.png';

// ==============================|| PROVIDER LOGO ||============================== //

const ProviderLogo = () => <img src={Logo} alt={APP_PROVIDER_NAME} width="50" height="50" style={{ marginRight: 10 }} />;

export default ProviderLogo;
